import { render, staticRenderFns } from "./NexultraMarketingCampaignModal.vue?vue&type=template&id=8bb7c4d8&"
import script from "./NexultraMarketingCampaignModal.vue?vue&type=script&lang=js&"
export * from "./NexultraMarketingCampaignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports